export function PrivacyNotice() {
  return (
    <section className="privacy-card">
      <div>
        <strong>Privacidade:</strong> seus arquivos AFD não são enviados para nenhum servidor. O site entrega apenas a interface; o processamento acontece localmente no navegador.
      </div>
      <div className="privacy-footnote">A política de segurança da página bloqueia chamadas de rede feitas pelo app em produção.</div>
    </section>
  );
}
